import React from "react";
import { motion } from "framer-motion";
import { TECHNOLOGY } from "../../data/site";

export const TechnologySection = () => {
  return (
    <section data-testid="technology-section" className="relative bg-[#F8FAFC] py-24 md:py-32 border-t border-[#E2E8F0] overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-6">
            <div className="eyebrow mb-4">// Technology · 04</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95]">
              Engineering<br />the <span className="text-[#0EA5E9]">core stack</span>
            </h2>
          </div>
          <div className="md:col-span-6 flex items-end">
            <p className="text-base md:text-lg text-[#475569] leading-relaxed max-w-xl">
              Industrial-grade components, deterministic motion control, and welding-process
              expertise — assembled into systems that perform shift after shift, year after year.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {TECHNOLOGY.map((t, i) => (
            <motion.div
              key={t.code}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              className="spec-card p-8 flex flex-col"
              data-testid={`tech-${t.code}`}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-mono-wm text-[10px] tracking-[0.3em] text-[#0EA5E9]">
                  {t.code} · {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl uppercase text-slate-900 tracking-tight leading-tight">{t.t}</h3>
              <p className="mt-3 text-sm text-[#475569] leading-relaxed">{t.d}</p>
            </motion.div>
          ))}
        </div>

        {/* partner logos strip */}
        <div className="mt-14 border border-[#E2E8F0] bg-[#F8FAFC] py-6 px-6 flex flex-wrap items-center gap-x-12 gap-y-4 justify-between">
          <span className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#64748B]">// Trusted Stack</span>
          {["EWM GERMANY", "OMRON PLC", "HOT WIRE TIG", "SERVO DRIVE", "INDUSTRY 4.0"].map((l) => (
            <span key={l} className="font-display tracking-wider text-[#0F172A] text-sm md:text-base">{l}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;
